var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    { attrs: { "is-modified": !!_vm.value.length, label: "スカウト特典" } },
    _vm._l(_vm.specialFavorsMaster, function (option, i) {
      return _c(
        "label",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: { content: option.description },
              expression: "{ content: option.description}",
            },
          ],
          key: i,
          staticClass: "boss-scout-bonus pega-mr-5 pega-input",
        },
        [
          _c("input", {
            attrs: { "data-test": "option-" + option.id, type: "checkbox" },
            domProps: {
              checked: _vm.value.includes(option.id.toString()),
              value: option.id,
            },
            on: { change: _vm.onChange },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "boss-bonus-check-text boss-bonus-check-mark",
              attrs: { "data-test": "option-name-" + option.id },
            },
            [_vm._v(_vm._s(option.name))]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }